import { defineStore } from 'pinia'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user') || 'null')
  }),

  actions: {
    async login(email, password) {
      console.log('[AUTH] login() called with:', email)
      const res = await axios.post('/login', { email, password })

      this.token = res.data.access_token
      localStorage.setItem('token', this.token)
      console.log('[AUTH] Token set:', this.token)
      localStorage.setItem('refresh_token', res.data.refresh_token)
      console.log('[AUTH] Refresh token:', res.data.refresh_token)

      const decoded = JSON.parse(atob(this.token.split('.')[1]))
      this.user = { email: decoded.email, role: decoded.role }
      localStorage.setItem('user', JSON.stringify(this.user))
      console.log('[AUTH] User set:', this.user)
    },

    // async refreshToken() {
    //   console.log('[AUTH] refreshToken() called')

    //   try {
    //     const res = await axios.post('/refresh')
    //     this.token = res.data.access_token
    //     localStorage.setItem('token', this.token)
    //     console.log('[AUTH] Token refreshed:', this.token)

    //     const decoded = JSON.parse(atob(this.token.split('.')[1]))
    //     this.user = { email: decoded.email, role: decoded.role }
    //     localStorage.setItem('user', JSON.stringify(this.user))
    //     console.log('[AUTH] User refreshed:', this.user)

    //     return true
    //   } catch (err) {
    //     console.warn('[AUTH] Token refresh failed:', err)
    //     this.logout()
    //     return false
    //   }
    // },

    // async refreshToken() {
    //   console.log('[AUTH] refreshToken() called')

    //   try {
    //     const refreshToken = localStorage.getItem('refresh_token')
    //     const res = await axios.post('/refresh', { refresh_token: refreshToken })

    //     this.token = res.data.access_token
    //     localStorage.setItem('token', this.token)
    //     localStorage.setItem('refresh_token', res.data.refresh_token)
    //     console.log('[AUTH] Token refreshed:', this.token)

    //     const decoded = JSON.parse(atob(this.token.split('.')[1]))
    //     this.user = { email: decoded.email, role: decoded.role }
    //     localStorage.setItem('user', JSON.stringify(this.user))
    //     console.log('[AUTH] User refreshed:', this.user)

    //     return true
    //   } catch (err) {
    //     console.warn('[AUTH] Token refresh failed:', err)
    //     this.logout()
    //     return false
    //   }
    // },

    async refreshToken() {
      console.log('[AUTH] refreshToken() called')

      try {
        const refreshToken = localStorage.getItem('refresh_token')
        const res = await axios.post('/refresh', { refresh_token: refreshToken })

        this.token = res.data.access_token
        localStorage.setItem('token', this.token)
        localStorage.setItem('refresh_token', res.data.refresh_token)

        axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`  // ✅ REQUIRED
        

        console.log('[AUTH] Token refreshed:', this.token)

        const decoded = JSON.parse(atob(this.token.split('.')[1]))
        this.user = { email: decoded.email, role: decoded.role }
        localStorage.setItem('user', JSON.stringify(this.user))
        console.log('[AUTH] User refreshed:', this.user)

        return true
      } catch (err) {
        console.warn('[AUTH] Token refresh failed:', err)
        this.logout()
        return false
      }
    },


    logout() {
      console.log('[AUTH] logout() called')
      this.token = null
      this.user = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
  }
})
